import React from 'react';
import { ArrowRightIcon, CheckCircle2Icon } from 'lucide-react';
import { CHECKOUT_URL } from '../utils/constants';
interface CTAButtonProps {
  label: string;
  sub?: string;
  id?: string;
  variant?: 'primary' | 'outline';
}
export function CTAButton({
  label,
  sub,
  id,
  variant = 'primary'
}: CTAButtonProps) {
  const base = 'group w-full inline-flex items-center justify-center gap-3 rounded-2xl px-5 py-5 text-center text-[16px] sm:text-lg font-extrabold uppercase tracking-tight leading-tight transition-[transform,background-color,box-shadow] duration-200 ease-out active:scale-[0.985] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-cta/30';
  const styles = variant === 'primary' ? 'bg-cta text-white shadow-[0_10px_0_-2px_rgba(19,133,62,0.55),0_18px_35px_-12px_rgba(10,37,64,0.45)] hover:bg-cta-dark' : 'bg-white text-ink border-2 border-ink/15 hover:border-ink/35 shadow-[0_6px_18px_-10px_rgba(10,37,64,0.5)]';
  return <div id={id} className="w-full max-w-xl mx-auto scroll-mt-24" data-id="element-38" data-mp="198wkn9dori4l">
      <a href={CHECKOUT_URL} className={`${base} ${styles}`} data-id="element-39" data-mp="19appqk8nhuah">
        {variant === 'primary' ? <CheckCircle2Icon className="hidden sm:block h-7 w-7 shrink-0" aria-hidden="true" data-id="element-40" data-mp="1dartr01uyzsx" /> : null}
        <span className="text-balance" data-id="element-41" data-mp="1n97aqa768sop">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-42" data-mp="1n9z7hoci8wgk" />
      </a>
      {sub ? <p className="mt-3 text-center text-[13px] sm:text-sm font-medium text-ink-soft" data-id="element-43" data-mp="1w7jb33xub4uc">
          {sub}
        </p> : null}
    </div>;
}